export default __webpack_public_path__ + "static/media/excel.97ff37f9.svg";